import type {RootState} from "../store";
import type {DraftContent} from "./exericseDraftSlice";

function selectExerciseDraft(state: RootState): DraftContent | null {
	return state.ui.exerciseDraft.draft;
}

export default selectExerciseDraft;
